<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;padding-top: 20px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addBtn()">新增</el-button>
<!--        <el-input prefix-icon="el-icon-search" placeholder="输入套餐名称查询" style="width: 250px"></el-input>-->
<!--        <el-button type="success" @click="queryDataTable">查询</el-button>-->
      </div>
      <div style="max-height: calc(100% - 120px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="套餐名称"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="price"
            label="原价"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.price}}元</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="desc"
            label="套餐说明"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            label="餐厅"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span>{{getRestaurantName(scope.row.restaurantid)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="总卡路里"
            width="80"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.kcal !== ''">{{scope.row.kcal}} kcal</span>
            </template>
          </el-table-column>
          <el-table-column
            label="菜品"
            min-width="140"
            align="center">
            <template slot-scope="scope">
              <table border="1" style="border-collapse: collapse;border: #d3d4d5;margin: auto" v-if="scope.row.dishcnts.length !== 0">
                <tr v-for="tag in scope.row.dishcnts" :key="tag.id">
                  <td style="padding: 5px 15px">{{tag.name}} / {{tag.cnt}}份</td>
                  <td style="padding: 5px 15px" v-if="tag.nutrients !== ''">
                    <div>
                      <span>碳水化合物:{{tag.nutrients.CHO}}克</span><br>
                      <span>蛋白质:{{tag.nutrients.PRO}}克</span><br>
                      <span>脂肪:{{tag.nutrients.FAT}}克</span><br>
                      <span>糖类:{{tag.nutrients.SUG}}克</span><br>
                      <span>膳食纤维:{{tag.nutrients.DF}}克</span>
                    </div>
                  </td>
                </tr>
              </table>
            </template>
          </el-table-column>
          <el-table-column
            label="图片"
            min-width="190"
            align="center">
            <template slot-scope="scope">
              <img style="height: 120px" v-for="item in scope.row.dishcnts" :key="item.index" v-if="item.picture" :src="url + item.picture + '?token=' + token">
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDishes(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-meal :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-meal>
    </el-dialog>
  </div></template>

<script>
import {querydish, queryingredient, queryrestaurant, querydishpackage, deletedishpackage} from '../../api/yanglaoyuan'
import addEditMeal from './components/addEditMeal'
import {getToken} from '../../utils/auth'
export default {
  name: 'setMeal',
  components: {addEditMeal},
  data () {
    return {
      token: '',
      entityId: 0,
      restaurants: [], // 餐厅
      ingredients: [], // 食材
      dishes: [], // 菜品
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        restaurants: [], // 餐厅
        ingredients: [], // 食材
        dishes: [], // 菜品
        isAdd: true,
        row: ''
      },
      url: ''
    }
  },
  created () {
    this.url = this.commonType.getapi() + 'food/image/'
    this.token = getToken()
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getRestaurants()
  },
  methods: {
    // 餐厅
    getRestaurants () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryrestaurant(params, data).then(res => {
        this.restaurants = res.data.restaurants
        this.addEditObj.restaurants = res.data.restaurants
        this.getIngredients()
      })
    },
    // 食材
    getIngredients () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryingredient(params, data).then(res => {
        this.ingredients = res.data.ingredients
        this.addEditObj.ingredients = res.data.ingredients
        this.queryDish()
      })
    },
    // 菜品
    queryDish () {
      this.tableData = []
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      querydish(params, data).then(res => {
        this.dishes = res.data.dishes
        this.addEditObj.dishes = res.data.dishes
        this.queryDataTable()
      })
    },
    queryDataTable () {
      this.tableData = []
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId
      }
      querydishpackage(params, data).then(res => {
        let arr = []
        res.data.dishpackages.forEach(item => {
          item.kcal = ''
          item.dishcnts.map(val => {
            if (val.dish_kcal !== '') {
              if (item.kcal === '') {
                item.kcal = parseFloat(val.dish_kcal)
              } else {
                item.kcal = item.kcal + parseFloat(val.dish_kcal)
              }
            }
            val.nutrients = val.dish_nutrients !== '' ? JSON.parse(val.dish_nutrients) : ''
          })
          arr.push(item)
        })
        // console.log(555, arr)
        this.tableData = arr
        this.totalCells = res.data.cnt
      })
    },
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name
    },
    addBtn () {
      this.addEditTitle = '新增套餐'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑套餐'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delDishes (row) {
      this.$confirm('此操作将永久删除该套餐【' + row.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletedishpackage(data).then(res => {
          this.$notify({title: '成功', message: '成功删除套餐', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        })
      })
    },
    updateTable () {
      this.queryDataTable()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/setMeal.vue